/**
 * Client-Side Translation Loader
 * ================================
 * Fetches translations from the Express API endpoint on SPA navigation.
 *
 * Used by: translationClientMiddleware (appReducer) during client-side routing
 */

/**
 * Fetch translations from the server API for the given language and tags.
 * Server filters by tags and resolves the target language with English fallback.
 *
 * @param langCode - Internal language code (e.g., 'zh', 'fr', 'zhtw')
 * @param tags - Route tags to load (e.g., ['search', 'property'])
 * @returns Flat key-value map of translations
 */
export async function loadTranslationsCSR(
  langCode: string,
  tags: string[],
): Promise<Record<string, string>> {
  // Send the internal language code (e.g. "zh") — the server maps it to the
  // filesystem code ("zh-Hans") via getLanguageFileCode inside loadTranslationsSSR.
  const response = await fetch(`/api/i18n/${langCode}?tags=${tags.join(",")}`, {
    headers: { Accept: "application/json" },
  });

  if (!response.ok) {
    throw new Error(`[i18n] CSR fetch failed: HTTP ${response.status}`);
  }

  const data = await response.json();
  return data as Record<string, string>;
}

export default loadTranslationsCSR;
